import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const appUserStatusSchema = z.enum(['active', 'blocked'])
export type AppUserStatus = z.infer<typeof appUserStatusSchema>

export const preferredLanguageSchema = z.enum(['en', 'hi'])
export type PreferredLanguage = z.infer<typeof preferredLanguageSchema>

export const updateAppUserSchema = z.object({
  name: z.string().max(200).optional(),
  email: z.string().email().optional(),
  mobile: z.string().max(20).optional(),
  preferred_language: preferredLanguageSchema.optional(),
  status: appUserStatusSchema.optional(),
})

export type UpdateAppUserInput = z.infer<typeof updateAppUserSchema>

export type AppUserResponse = {
  id: string
  legacy_id?: string | null
  name?: string | null
  email: string
  mobile?: string | null
  preferred_language: PreferredLanguage
  status: AppUserStatus
  created_at: string
  updated_at: string
}

export type AppUserSortBy = 'created_at' | 'email' | 'name'

export type PaginatedAppUserResponse = PaginatedResponse<AppUserResponse>
